import { FC, useMemo } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import classNames from 'classnames';
import { LinhaTempo, LinhaTempoTipo } from '../../../../@types/linha-tempo';

const ITENS_LAYOUT: Record<LinhaTempoTipo, ItemLayout> = {
  tarefa: {
    textColor: '#1d84c5',
    backgroundColor: '#d7eeff',
    icon: 'icon-task',
    label: 'Tarefa',
  },
  anotacao: {
    textColor: '#e74a3c',
    backgroundColor: '#fcdcd9',
    icon: 'icon-note',
    label: 'Anotação',
  },
  ocorrencia: {
    textColor: '#f09e1b',
    backgroundColor: '#ffeda5',
    icon: 'icon-invader',
    label: 'Ocorrência',
  },
  tratamentoSementes: {
    textColor: '#e74a3c',
    backgroundColor: '#fcdcd9',
    icon: 'icon-seeds',
    label: 'Tratamento de sementes',
  },
};

const LinhaTempoItem: FC<PropTypes> = ({ item, dates }) => {
  const overflowLastDate = useMemo(() => {
    const lastDateUnix = Math.max(...dates.map((date) => date.valueOf()));

    return item.dataTermino.valueOf() > lastDateUnix;
  }, [dates, item]);

  const layout = ITENS_LAYOUT[item.tipo];

  const dateRangeLabel = useMemo(() => {
    const isSingleDay = dayjs(item.dataInicio).isSame(item.dataTermino, 'day');

    if (isSingleDay || overflowLastDate) return;

    const formatDate = (date: Date) => dayjs(date).format('DD/MMM');

    return `${formatDate(item.dataInicio)} - ${formatDate(item.dataTermino)}`;
  }, [item.dataInicio, item.dataTermino, overflowLastDate]);

  return (
    <div
      className={classNames(
        'm-1 p-2 border-round-lg align-items-center white-space-nowrap flex',
        { 'border-noround-right': overflowLastDate },
      )}
      style={{
        backgroundColor: layout.backgroundColor,
        color: layout.textColor,
      }}
    >
      <i className={`${layout.icon} mr-2 text-xl`} />
      <span className="overflow-hidden text-overflow-ellipsis">
        {layout.label}
      </span>
      <span className="font-medium ml-auto">{dateRangeLabel}</span>
    </div>
  );
};

type PropTypes = {
  item: LinhaTempo;
  dates: Dayjs[];
};

export default LinhaTempoItem;

type ItemLayout = {
  label: string;
  icon: string;
  textColor: string;
  backgroundColor: string;
};
